import { z } from 'zod/v4';

export const MAILBOX_TYPES = ['inbox', 'outbox', 'drafts'] as const;

export type MailboxType = (typeof MAILBOX_TYPES)[number];

export const MailboxTypeSchema = z.enum([...MAILBOX_TYPES]);
